module.exports = __webpack_public_path__ + "static/01_PLATOS-MEXICO-TACOSD.50723846.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/players/01_PLATOS-MEXICO-TACOSD.png
// module id = 691
// module chunks = 35783957827783